import { keymap } from 'prosemirror-keymap';
import type { Schema } from 'prosemirror-model';
import type { EditorView } from 'prosemirror-view';

import { WysiwygShortcuts } from '@core/wysiwyg-legacy';

import type { EmSchema } from './italic-mark';
import type { EditorButton, EditorMode, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY, metaKey } from '../../../helpers/utils';

export class ItalicService<S extends EmSchema> extends MarkService<S> {}

export class ItalicPlugin implements RtPMPlugin {
  public api: { italicService: ItalicService<Schema> };
  public buttons = {
    toggleItalic: <EditorButton>{
      icon: 'format-ital',
      tooltipText: 'wysiwyg.italic',
      tooltipShortcut: WysiwygShortcuts.Italic(metaKey),
      isActive: (...args) => this.api.italicService.isActive(...args),
      run: (state, dispatch) => {
        this.api.italicService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView;

  public beforeInit(mode: EditorMode, schema: EmSchema) {
    this.api = {
      italicService: new ItalicService(schema.marks.em),
    };
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: EmSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: EmSchema) {
    return {
      'Mod-I': toggleMark(schema.marks.em),
      'Mod-i': toggleMark(schema.marks.em),
    };
  }
}
